(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['$state', 'User'];

    function ContactUsController($state, User) {
        var vm = this;

        vm.form = true;
        vm.contact = [];

        vm.contactUs = function (){

            var body = {
                email: vm.contact.email,
                name: vm.contact.name,
                message: vm.contact.message
            };

            User.sendHelpMail(body, onSuccess, onError);

            function onSuccess(){
                vm.form = false;
            }

            function onError(){}
        };
    }
})();
